import React from 'react';
import AnnouncementBar from './components/AnnouncementBar';
import Header from './components/Header';
import Hero from './components/Hero';
import BenefitsStrip from './components/BenefitsStrip';
import UnifiedServices from './components/UnifiedServices';
import HowItWorks from './components/HowItWorks';
import Credentials from './components/Credentials';
import ServiceArea from './components/ServiceArea';
import FAQ from './components/FAQ';
import FinalCTA from './components/FinalCTA';
import Footer from './components/Footer';
import ContactPage from './components/ContactPage';
import ServiceAreasPage from './components/ServiceAreasPage';
import MobileNotaryCityPage from './components/MobileNotaryCityPage';
import AboutPage from './components/AboutPage';
import ServicesPage from './components/ServicesPage';
import ServiceDetailPage from './components/ServiceDetailPage';
import PrivacyPolicyPage from './components/PrivacyPolicyPage';
import TermsOfServicePage from './components/TermsOfServicePage';
import { serviceAreas } from './data/serviceAreas';
import { serviceDetails } from './data/services';

function HomePage() {
  return (
    <div className="min-h-screen bg-cream flex flex-col selection:bg-brass selection:text-cream">
      <AnnouncementBar />
      <Header />
      <main className="flex-grow">
        <Hero />
        <BenefitsStrip />
        <UnifiedServices />
        <HowItWorks />
        <Credentials />
        <ServiceArea />
        <FAQ />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
}

function App() {
  const path = window.location.pathname.replace(/\/+$/, '') || '/';
  const citySlug = path.startsWith('/mobile-notary/')
    ? path.split('/').filter(Boolean)[1]
    : '';

  const city = serviceAreas.find((area) => area.slug === citySlug);
  const serviceSlug = path.startsWith('/services/')
    ? path.split('/').filter(Boolean)[1]
    : '';
  const service = serviceDetails[serviceSlug];

  if (path === '/contact') {
    return <ContactPage />;
  }

  if (path === '/service-areas') {
    return <ServiceAreasPage />;
  }

  if (path === '/about') {
    return <AboutPage />;
  }

  if (path === '/privacy-policy') {
    return <PrivacyPolicyPage />;
  }

  if (path === '/terms-of-service') {
    return <TermsOfServicePage />;
  }

  if (path === '/services') {
    return <ServicesPage />;
  }

  if (service) {
    return <ServiceDetailPage service={service} />;
  }

  if (city) {
    return <MobileNotaryCityPage city={city} />;
  }

  return <HomePage />;
}

export default App;